var map = {
	"./costal-1-1.jpg": "2ee9",
	"./costal-2-1.jpg": "a781",
	"./costal-3-1.jpg": "de96",
	"./costal-4-1.jpg": "849d",
	"./costal-5-1.jpg": "05c0",
	"./costal-6-1.jpg": "8483",
	"./costal-7-1.jpg": "8362",
	"./costal-8-1.jpg": "d678"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1cd6";